"use client";
import { Chip as DigDirChip } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const ChipButton = React.forwardRef(({ className, hero, "data-color": dataColor, "data-size": dataSize, ...props }, ref) => {
    return (React.createElement(DigDirChip.Button, { ref: ref, className: cn("in-chip__button", hero && "in-chip-hero", className), "data-size": hero ? "lg" : dataSize, "data-color": hero ? "primary" : dataColor, ...props }));
});
ChipButton.displayName = "ChipButton";
export { ChipButton };
//# sourceMappingURL=chipButton.js.map